// function to add ' after every 3 numbers
export const formatLargeNumbers = (number: string | number) => {
  const numberAsArr = number
    .toString()
    .split(/([\+\-\*\/\^\.\(\)]+)/g) as string[];
  // sometimes a ' can end at the start of the number
  // preformat to add "." and "," next to decimal.
  // In constant formattedInteger the decimal will not be be formatted
  let preFormatArr: string[] = [];
  let skipNext: boolean = false;
  numberAsArr.forEach((val, i, arr) => {
    if (val === "." || val === ",") {
      preFormatArr.push(val + arr[i + 1]);
      skipNext = true;
    } else if (skipNext) {
      skipNext = false;
    } else {
      preFormatArr.push(val);
    }
  });

  const formattedInteger = preFormatArr.map((val) => {
    // check if number
    // also if after "." or "," then it is decimals and no formatting needed
    return !isNaN(parseFloat(val)) &&
      isFinite(Number(val)) &&
      val.split("")[0] !== "." &&
      val.split("")[0] !== ","
      ? val
          .split("")
          .reverse()
          .map((n, i, arr) =>
            (i + 1) % 3 === 0 && i !== arr.length - 1 ? `'${n}` : n
          )
          .reverse()
          .join("")
      : val;
  });
  return formattedInteger.join("");
};

export const removeFormatLargeNumbers = (number: string) => {
  return number.split("'").join("");
};
